var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOptInOut = function SvgOptInOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-3);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 17.72,
    y1: 178.4,
    x2: 182.04,
    y2: 36.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 40.57,
    y1: 204.8,
    x2: 204.9,
    y2: 62.49,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -12.21,
    y1: 143.84,
    x2: 152.11,
    y2: 1.54,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.67,120c-18.38,0-33.33,14.95-33.33,33.33s14.95,33.33,33.33,33.33,33.33-14.95,33.33-33.33-14.95-33.33-33.33-33.33ZM46.67,180c-14.7,0-26.67-11.96-26.67-26.67s11.96-26.67,26.67-26.67,26.67,11.96,26.67,26.67-11.96,26.67-26.67,26.67Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M153.33,106.67H46.67C20.93,106.67,0,127.6,0,153.33s20.93,46.67,46.67,46.67h106.67c25.73,0,46.67-20.93,46.67-46.67s-20.93-46.67-46.67-46.67ZM153.33,193.33H46.67c-22.06,0-40-17.94-40-40s17.94-40,40-40h106.67c22.06,0,40,17.94,40,40s-17.94,40-40,40Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M46.67,93.33h106.67c25.73,0,46.67-20.93,46.67-46.67S179.07,0,153.33,0H46.67C20.93,0,0,20.93,0,46.67s20.93,46.67,46.67,46.67ZM153.33,13.33c18.38,0,33.33,14.95,33.33,33.33s-14.95,33.33-33.33,33.33-33.33-14.95-33.33-33.33,14.95-33.33,33.33-33.33Z"
  })));
};
export default SvgOptInOut;